import { render, staticRenderFns } from "./JoszakiHtmlTextBlock.vue?vue&type=template&id=1e487620"
import script from "./JoszakiHtmlTextBlock.vue?vue&type=script&lang=js"
export * from "./JoszakiHtmlTextBlock.vue?vue&type=script&lang=js"
import style0 from "./JoszakiHtmlTextBlock.vue?vue&type=style&index=0&id=1e487620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports